// src/components/guide/motion.js
// Web Animations helpers. Each resolves immediately, without touching the DOM, under reduced motion.
const HUES = ['indigo', 'violet', 'fuchsia', 'pink', 'amber', 'emerald', 'sky', 'teal'];
export const prefersReducedMotion = () => typeof window === 'undefined' || Boolean(window.matchMedia?.('(prefers-reduced-motion: reduce)').matches);
const center = el => { const r = el.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; };
const layer = () => {
  let host = document.getElementById('guide-motion-layer');
  if (!host) { host = document.createElement('div'); host.id = 'guide-motion-layer'; host.className = 'guide-motion-layer'; host.setAttribute('aria-hidden', 'true'); document.body.appendChild(host); }
  return host;
};
const play = (el, keyframes, options) => (el.animate ? el.animate(keyframes, options).finished.catch(() => {}) : Promise.resolve()).finally(() => el.remove?.());
const spawn = (className, { x, y }, color) => { const el = document.createElement('span'); el.className = className; el.style.left = `${x}px`; el.style.top = `${y}px`; if (color) el.style.background = color; layer().appendChild(el); return el; };

export function burst(el, { count = 24 } = {}) {
  if (!el || prefersReducedMotion()) return Promise.resolve();
  const origin = center(el);
  return Promise.all(Array.from({ length: count }, (_, i) => {
    const angle = (Math.PI * 2 * i) / count + Math.random() * 0.4, dist = 40 + Math.random() * 60;
    const p = spawn('guide-particle', origin, `var(--c-${HUES[i % HUES.length]})`);
    return play(p, [{ transform: 'translate(-50%,-50%) scale(1)', opacity: 1 }, { transform: `translate(calc(-50% + ${Math.cos(angle) * dist}px), calc(-50% + ${Math.sin(angle) * dist}px)) scale(.2)`, opacity: 0 }], { duration: 900, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'forwards' });
  })).then(() => undefined);
}

export async function collect(fromEl, toEl) {
  if (!toEl || prefersReducedMotion()) return;
  const to = center(toEl), from = fromEl ? center(fromEl) : { x: window.innerWidth / 2, y: window.innerHeight / 2 };
  const star = spawn('guide-star', from);
  const dx = to.x - from.x, dy = to.y - from.y;
  await play(star, [
    { transform: 'translate(-50%,-50%) scale(.6)', opacity: 0 },
    { transform: `translate(calc(-50% + ${dx * 0.4}px), calc(-50% + ${dy * 0.4 - 80}px)) scale(1.3)`, opacity: 1, offset: 0.45 },
    { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) scale(.5)`, opacity: 1 },
  ], { duration: 800, easing: 'cubic-bezier(.4,0,.2,1)', fill: 'forwards' });
  await burst(toEl, { count: 14 });
}

export async function finale(dockEl) {
  if (!dockEl || prefersReducedMotion()) return;
  dockEl.classList.add('guide-finale');
  burst(dockEl, { count: 40 });
  await new Promise(resolve => setTimeout(resolve, 2400));
  dockEl.classList.remove('guide-finale');
}
